import React, { Component } from "react";
import { connect } from "react-redux";
import { resetPassword } from "../store/actions/authActions";
import { Redirect, Link } from "react-router-dom";
import "./ForgotPassword.css";
import { Button, Form } from "semantic-ui-react";

class ForgotPassword extends Component {
  state = {
    email: "",
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.resetPassword(this.state);
  };

  render() {
    const { authError, auth, passwordReset } = this.props;

    if (auth.uid) {
      return <Redirect to="/admin" />;
    } else {
      if (passwordReset) {
        return (
          <>
            <div className="ForgotPasswordBackground">
              <div className="ForgotPasswordBannerBar"></div>
              <div className="ForgotPasswordContainer">
                <div className="CheckEmail">
                  <h3>Success!</h3>
                  <p>Please search your Email Inbox with the keywords <b>"Collegiate Sports Advocate"</b>.<br/> If the Password Reset Email is not in your Inbox, please check your Spam or Trash Folders as well.</p>
                  <Link to="/login">
                    <Button>OK</Button>
                  </Link>
                </div>
              </div>
            </div>
          </>
        );
      } else {
        return (
          <>
            <div className="ForgotPasswordBackground">
              <div className="ForgotPasswordBannerBar"></div>
              <div className="ForgotPasswordContainer">
                <div className="ForgotPassword">
                  <Form onSubmit={this.handleSubmit}>
                    <div className="LoginHeader">
                      <h1>Forgot Password</h1>
                    </div>
                    <Form.Field>
                      <label>Email</label>
                      <input
                        type="email"
                        placeholder="Email"
                        id="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                      />
                    </Form.Field>
                    <div className="ForgotPasswordButtonGroup">
                      <div className="ForgotPasswordResetInstructions">
                        <p>We’ll send you an email to reset your password.</p>
                      </div>
                      <div className="ButtonMessageContainer">
                        <Button type="submit">Reset Password</Button>
                        {authError ? <p>{authError}</p> : null}
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
    passwordReset: state.auth.passwordReset,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (creds) => dispatch(resetPassword(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
